<template>
  <div class="row">
      <a-spin :spinning="isLoading">
      <!-- Steps -->
      <div class="col-md-12">
        <a-steps :current="current" style="width: 100%">
          <a-step v-for="item in steps" :key="item.title">
            <template #title>
              <div style="white-space: normal; text-align: center; max-width: 120px;">
                {{ item.title }}
              </div>
            </template>
          </a-step>
        </a-steps>
      </div>


      <hr class="mt-1 mb-2">
      
      <!-- Basic Information -->
      <div v-if="current === 0" class="col-md-12 p-4">
          <h2>Basic Information</h2>
          <p>{{  this.steps[0].description }}</p>
          <div class="form-group">
              <label for="auto-rep-name">Name</label>
              <base-input
              id="auto-rep-name"
              v-model="autoRepName"
              placeholder="Enter a name for this auto-replenishment"
              maxlength="15"
              />
          </div>

          <div class="form-group mt-3">
              <label for="auto-rep-code">Code</label>
              <base-input
              id="auto-rep-code"
              v-model="autoRepCode"
              placeholder="Enter a unique code"
              maxlength="15"
              />
          </div>
      </div>

      <!-- Replenishment By -->
      <div v-if="current === 1" class="col-md-12 p-4">
        <h2>Replenishment By</h2>
        <p>{{  this.steps[1].description }}</p>
        <a-radio-group v-model="replenishmentBy">
          <a-radio :value="1">Offtake (Sales)</a-radio><br />
          <a-radio :value="2">Min/Max Quantity</a-radio>
        </a-radio-group> <br/><br/>

        <div v-if="replenishmentBy == '1'">
          <h2>Look Back Date Range</h2>
          <p>Define the historical period used for replenishment analysis.</p>
          <a-radio-group v-model="lookBackType">
            <a-radio value="D">Based on number of days</a-radio><br />
            <a-radio value="W">Based on number of weeks</a-radio><br />
            <a-radio value="M">Based on number of months</a-radio><br />
          </a-radio-group>
          <br/><br/>
          <div v-if="lookBackType">
            <a-input-number
              label="Lookback value"
              v-model="lookBackValue"
              :min="1"
              :max="maxValues[lookBackType]"
              style="width: 200px"
            />
            <div style="margin-top: 4px; color: #888;">
              Max: {{ maxValues[lookBackType] }}
              {{ lookBackType === 'D' ? 'days' : lookBackType === 'W' ? 'weeks' : 'months' }}
            </div>
          </div>

          <!-- <a-radio-group v-model="lookBack">
            <a-radio :value="'7D'">7 Days</a-radio><br />
            <a-radio :value="'1W'">1 Week</a-radio><br />
            <a-radio :value="'3W'">3 Weeks</a-radio><br />
            <a-radio :value="'1M'">1 Month</a-radio><br />
            <a-radio :value="'3M'">3 Months</a-radio>
          </a-radio-group> -->
        </div>

      </div>
  
      <!-- Output Document -->
      <div v-if="current === 2" class="col-md-12 p-4">
        <h2>Output Document</h2>
        <p>{{  this.steps[2].description }}</p>
        <a-radio-group v-model="outputDocument">
          <a-radio :value="'ORIPOX'">Confirmed Purchase Order</a-radio><br />
          <a-radio :value="'OTHTRA'">Confirmed Transfer Allocation</a-radio>
        </a-radio-group>
      </div>
  
      <!-- Look Back Date Range -->
      <!-- <div v-if="current === 3" class="col-md-12 p-4">
        <h2>Look Back Date Range</h2>
        <p>{{  this.steps[3].description }}</p>
        <a-radio-group v-model="lookBack">
          <a-radio :value="'7D'">7 Days</a-radio><br />
          <a-radio :value="'1W'">1 Week</a-radio><br />
          <a-radio :value="'3W'">3 Weeks</a-radio><br />
          <a-radio :value="'1M'">1 Month</a-radio><br />
          <a-radio :value="'3M'">3 Months</a-radio>
        </a-radio-group>
      </div> -->
  
      <!-- Target Sites -->
      <div v-if="current === 3" class="col-md-12 p-4">
        <h2>Source Site</h2>
        <p>{{  this.steps[3].description }}</p>
        <a-select  v-model="inputSite" showSearch optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
            <a-select-option v-for="option in siteOptionsMain" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
        </a-select> <br /> <br />

        <h2>Target Sites</h2>
        <div class="row ml-3">
          <div class="col-md-12">
            <base-radio name="A" v-model="site_selection">
              All Sites with Auto-rep Enabled (default)
            </base-radio>
            <br />
            <base-radio name="S" v-model="site_selection">
              Specific Site
            </base-radio>
  
            <!-- Specific Site Options -->
            <div v-if="site_selection === 'S'" class="col-md-8 mt-3">
              <!-- Site Search -->
              <a-input-search
                v-model="searchQuery"
                @input="filterSites"
                placeholder="Search Sites"
                :allowClear="true"
                style="width: 100%; margin-bottom: 10px;"
              />
  
              <!-- Manual Site Code Input -->
              <div class="mb-3">
                <!-- <h6 class="heading-small text-muted">Enter Site Codes</h6>
                <a-input
                  v-model="siteCodesInput"
                  placeholder="Enter site codes separated by commas"
                  style="width: 100%;"
                />
                <p class="text-muted mt-1" style="font-size: 14px;">
                  Note: Enter site codes separated by commas. Example: (site_code1, site_code2, site_code3)
                </p> -->
  
                <!-- Site Code Actions -->
                <div class="mt-2">
                  <!-- <a-button @click="processSiteCodesInput" type="default">Tag Sites</a-button> -->
                  <a-button @click="clearSiteCodes" type="danger" class="ml-2">Clear</a-button>
                  <a-button @click="showSelectedSites" type="primary" class="ml-2">View Selected Sites</a-button>
                </div>
              </div>
  
              <!-- Site Tree -->
              <a-tree
                ref="tree"
                checkable
                :defaultCheckedKeys="selectedRowKeys"
                :checkedKeys="selectedRowKeys"
                :treeData="filteredLocationData"
                :disabled="viewOnly"
                @check="onCheckSiteId"
              />
  
              <!-- No Results Found -->
              <div
                v-if="filteredLocationData.length === 0"
                class="text-muted pt-4"
                style="font-size: 14px;"
              >
                No results found for the given search query.
              </div>
  
              <!-- Selected Sites Modal -->
              <a-modal
                v-model:visible="isModalVisible"
                title="Selected Sites"
                @ok="handleOk_"
                @cancel="handleCancel"
              >
                <ul>
                  <li v-for="site in selectedSites" :key="site.key">{{ site.title }}</li>
                </ul>
              </a-modal>
            </div>
          </div>
        </div>
      </div>
  
      <!-- Schedule -->
      <div v-if="current === 4" class="col-md-12 p-4">
          <h2>Schedule</h2>
          <p>{{  this.steps[4].description }}</p>
          <a-radio-group v-model="schedule">
              <a-radio :value="1">Once a week</a-radio><br />
              <a-radio :value="2">Every 1st day of the month</a-radio><br />
              <a-radio :value="3">Every last day of the month</a-radio><br />
              <!-- <a-radio :value="4">CRON</a-radio><br /> -->
              <a-radio :value="5">MANUAL</a-radio>
          </a-radio-group>

          <br/><br/>
          <div v-if="schedule === 1" class="mt-2">
            <small>Please select what day of the week: </small> <br/>
            <a-select
              v-model="selectedDay"
              placeholder="Select a day"
              style="width: 200px"
            >
              <a-select-option value="MON">Monday</a-select-option>
              <a-select-option value="TUE">Tuesday</a-select-option>
              <a-select-option value="WED">Wednesday</a-select-option>
              <a-select-option value="THU">Thursday</a-select-option>
              <a-select-option value="FRI">Friday</a-select-option>
              <a-select-option value="SAT">Saturday</a-select-option>
              <a-select-option value="SUN">Sunday</a-select-option>
          </a-select>
        </div>


          <!-- <div v-if="schedule === 4" class="mt-3 overflow-x-auto">
            <div class="row">
              <div class="col-2">
                <label class="text-sm font-medium mb-1">Minute</label>
                <a-input v-model="cronParts[0]" placeholder="*" class="w-full" @input="updateCronPart(0, $event.target.value)" />
              </div>

              <div class="col-2">
                <label class="text-sm font-medium mb-1">Hour</label>
                <a-input v-model="cronParts[1]" placeholder="*" class="w-full" @input="updateCronPart(1, $event.target.value)"/>
              </div>

              <div class="col-2">
                <label class="text-sm font-medium mb-1">Day of Month</label>
                <a-input v-model="cronParts[2]" placeholder="*" class="w-full" @input="updateCronPart(2, $event.target.value)"/>
              </div>

              <div class="col-2">
                <label class="text-sm font-medium mb-1">Month</label>
                <a-input v-model="cronParts[3]" placeholder="*" class="w-full" @input="updateCronPart(3, $event.target.value)"/>
              </div>

              <div class="col-2">
                <label class="text-sm font-medium mb-1">Day of Week</label>
                <a-input v-model="cronParts[4]" placeholder="*" class="w-full" @input="updateCronPart(4, $event.target.value)"/>
              </div>

              <div class="col-2">
                <label class="text-sm font-medium mb-1">Year</label>
                <a-input v-model="cronParts[5]" placeholder="*" class="w-full" @input="updateCronPart(5, $event.target.value)"/>
              </div>
            </div>

            <div class="text-danger mt-2 text-sm" v-if="!isValidCron && customCron">
              Invalid CRON expression: {{  this.cronError }}
            </div>
          </div> -->

      </div>

      </a-spin>
  
      <!-- Action Buttons -->
      <div class="position-absolute" style="bottom: 20px; right: 20px;">
        <div class="d-flex justify-content-end gap-2">
          <b-button
            v-if="showPrevious"
            size="sm"
            variant="secondary"
            @click="prevAutoRepStep"
          >
            Previous
          </b-button>
  
          <b-button
            v-if="showNext"
            size="sm"
            variant="primary"
            @click="nextAutoRepStep"
          >
            Next
          </b-button>
  
          <b-button
            v-if="showCreate"
            size="sm"
            variant="primary"
            :loading="loading"
            @click.prevent="autoRepAction(1)"
          >
            Create AutoRep
          </b-button>
  
          <b-button
            v-if="showSave"
            size="sm"
            variant="primary"
            :disabled="viewMode !== false"
            :loading="loading"
            @click.prevent="autoRepAction(2)"
          >
            Save
          </b-button>
  
          <b-button
            v-if="showDisabledCreate"
            size="sm"
            variant="primary"
            disabled
          >
            Create AutoRep
          </b-button>
  
          <b-button
            v-if="showDisabledSave"
            size="sm"
            variant="primary"
            disabled
          >
            Save
          </b-button>
        </div>
      </div>
  </div>
</template>


<script>
import secureStorage from '../../controllers/secureStorage';
import HTTPRequest from '../../controllers/httpRequest.js';
import { mapState, mapActions } from 'vuex';

const getNotificationStyle = type => {
  return {
      success: {
          color: 'rgba(0, 0, 0, 0.65)',
          border: '1px solid #b7eb8f',
          backgroundColor: '#f6ffed'
      },
      warning: {
          color: 'rgba(0, 0, 0, 0.65)',
          border: '1px solid #ffe58f',
          backgroundColor: '#fffbe6'
      },
      error: {
          color: 'rgba(0, 0, 0, 0.65)',
          border: '1px solid #ffa39e',
          backgroundColor: '#fff1f0'
      },
      info: {
          color: 'rgba(0, 0, 0, 0.65)',
          border: '1px solid #91d5ff',
          backgroundColor: '#e6f7ff'
      }
  }[type]
}

export default {
props: {
  viewMode: {
    type: Boolean,
    default: false,
  },
},

data() {
  return {
    loading: false, 
    isLoading: false,
    current: 0,
    searchQuery: '',
    siteCodesInput: '',
    site_selection: 'A',
    viewOnly: false,

    selectedRowKeys: [],
    selectedSites: [],
    isModalVisible: false,

    productLocationData: [],
    filteredLocationData: [],
    siteOptions: [],
    siteOptionsMain: [],
    inputSite: null,

    replenishmentBy: 1,
    outputDocument: 'ORIPOX',
    // lookBack: '7D',
    lookBackType: "D",
    lookBackValue: null,
      maxValues: {
        D: 90,
        W: 12,
        M: 3
    },
    schedule: 1,
    autoRepName: "",
    autoRepCode: "",
    customCron: "",
    isValidCron: true,
    cronError: "",
    selectedDay: "MON",
    steps: [
      {
          title: 'Basic Info',
          description: 'Enter a name and code for this auto-replenishment setup.',
      },
      {
        title: 'Auto-Replenishment By',
        description: 'Choose how replenishment is calculated: based on sales or min/max quantities.',
      },
      {
        title: 'Document Output',
        description: 'Set how the replenishment document will be generated.',
      },
      // {
      //   title: 'Look Back',
      //   description: 'Define the historical period used for replenishment analysis.',
      // },
      {
        title: 'Sites Configuration',
        description: 'Select which sites or branches to apply replenishment from & to.',
      },
      {
        title: 'Schedule',
        description: 'Set when and how often replenishment should run.',
      },
    ],
  };
},

watch: {
  customCron(value) {
    const result = this.validateAwsCron(value);
    if (!result.valid) {
      console.error("Invalid cron:", result.error);
      this.cronError = result.error
      this.isValidCron = false;
    } else {
      console.log("Valid AWS cron expression!");
      this.isValidCron = true;
    }
  }
},

computed: {
  ...mapState([
    'currentProfile',
    'currentApiURL',
    'endPoint',
    'parameters',
    'profileId',
    'serverType',
  ]),

  showPrevious() {
    return this.current > 0;
  },
  showNext() {
    return this.current < this.steps.length - 1;
  },
  showCreate() {
    return this.isLastStep && this.isHO && this.profileId === 0;
  },
  showSave() {
    return this.isLastStep && this.isHO && this.profileId !== 0;
  },
  showDisabledCreate() {
    return this.isLastStep && !this.isHO && this.profileId === 0;
  },
  showDisabledSave() {
    return this.isLastStep && !this.isHO && this.profileId !== 0;
  },
  isLastStep() {
    return this.current === this.steps.length - 1;
  },
  isHO() {
    return this.serverType === 'ho';
  },

  cronParts: {
    get() {
      // Split exactly into 6 parts, keeping empty ones
      const parts = this.customCron.split(' ');
      while (parts.length < 6) parts.push('');
      return parts;
    },
    set(newParts) {
      // Ensure exactly 6 elements, even if some are empty
      while (newParts.length < 6) newParts.push('');
      this.customCron = newParts.join(' ');
    },
  }
},

async mounted() {
  this.isLoading = true;

  try {
      let data = {};
      const isEditMode = this.profileId > 0;

      if (isEditMode) {
          data = await HTTPRequest.getRequest(`${this.endPoint}auto_replenishments/${this.profileId}`, null);
          console.log(data);

          const {
              name,
              code,
              replenishment_type,
              output_document_type,
              lookback,
              source_site_id,
              schedule: rawSchedule,
              auto_replenishment_site_ids
          } = data;

          let lookbackCopy = lookback;
          let lookBackType = null
          let lookBackValue = null
          if(replenishment_type == 1){
            lookBackType = lookbackCopy.slice(-1);
            lookBackValue = lookbackCopy.slice(0, -1)
          }

          Object.assign(this, {
              inputSite: source_site_id,
              autoRepName: name,
              autoRepCode: code,
              replenishmentBy: replenishment_type,
              outputDocument: output_document_type,
              lookBackType: lookBackType,
              lookBackValue: lookBackValue
          });

          const scheduleMap = {
              "0 0 1 * ? *": 2,
              "0 0 L * ? *": 3,
              "MANUAL": 5
          };
          this.schedule = scheduleMap[rawSchedule] || 1;
          if(this.schedule === 1){
            const parts = rawSchedule.trim().split(/\s+/);
            const dayOfWeek = parts[4];
            this.selectedDay = dayOfWeek
          }
          
      }

      const responseMain = await HTTPRequest.getRequest(`${this.endPoint}sites/get_valid_sites`);
      this.siteOptionsMain = responseMain;

      const response = await HTTPRequest.getRequest(`${this.endPoint}sites/get_valid_sites_autorep`);
      this.siteOptions = response;
      console.log(response);

      const allSiteIds = response.map(site => site.id);

      if (isEditMode) {
          const selectedIds = data.auto_replenishment_site_ids || [];
          const isAllSitesSelected = allSiteIds.length === selectedIds.length;

          this.site_selection = isAllSitesSelected ? "A" : "S";
          if (!isAllSitesSelected) this.selectedRowKeys = selectedIds;
      }

      this.sort(this.siteOptions);
      this.getLocationTreeData();
  } catch (error) {
      console.error("Failed to load auto replenishment data:", error);
      this.$message.error("Failed to load data.");
  } finally {
      this.isLoading = false;
  }
 },


methods: {
  ...mapActions(['updateCurrentProfile', 'updateParameters']),
  filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
  },

  validateAwsCron(value) {
    const parts = value.trim().split(/\s+/);

    if (parts.length !== 6) {
      return { valid: false, error: "Invalid cron: Must have exactly 6 fields (Minute Hour Day-of-month Month Day-of-week Year)" };
    }

    const [minute, hour, dayOfMonth, month, dayOfWeek, year] = parts;

    // Rule: You can't use * in both Day-of-month and Day-of-week — if one is *, the other must be ?
    if (dayOfMonth === "*" && dayOfWeek === "*") {
      return { valid: false, error: "Invalid cron: Cannot use '*' in both Day-of-month and Day-of-week. Use '?' in one of them." };
    }

    // Additional basic syntax checks (can be expanded)
    const fieldPatterns = {
      minute: /^(\*|[0-5]?\d)$/,
      hour: /^(\*|[01]?\d|2[0-3])$/,
      dayOfMonth: /^(\*|\?|0?[1-9]|[12]\d|3[01])$/,
      month: /^(\*|0?[1-9]|1[0-2]|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)$/,
      dayOfWeek: /^(\*|\?|[0-6]|SUN|MON|TUE|WED|THU|FRI|SAT)$/,
      year: /^(\*|19[7-9]\d|20\d{2}|2099)$/
    };

    if (!fieldPatterns.minute.test(minute)) return { valid: false, error: `Invalid Minute field: ${minute}` };
    if (!fieldPatterns.hour.test(hour)) return { valid: false, error: `Invalid Hour field: ${hour}` };
    if (!fieldPatterns.dayOfMonth.test(dayOfMonth)) return { valid: false, error: `Invalid Day-of-month field: ${dayOfMonth}` };
    if (!fieldPatterns.month.test(month)) return { valid: false, error: `Invalid Month field: ${month}` };
    if (!fieldPatterns.dayOfWeek.test(dayOfWeek)) return { valid: false, error: `Invalid Day-of-week field: ${dayOfWeek}` };
    if (!fieldPatterns.year.test(year)) return { valid: false, error: `Invalid Year field: ${year}` };

    return { valid: true, error: "" };
  },

  nextAutoRepStep() {
    if (this.current < this.steps.length - 1) this.current++;
  },
  prevAutoRepStep() {
    if (this.current > 0) this.current--;
  },

  updateCronPart(index, value) {
    // Split into exactly 6 parts, preserving empty ones
    const parts = this.customCron.split(' ');
    while (parts.length < 6) parts.push('');
    
    // Update the part
    parts[index] = value;

    // Keep exactly 6 parts, even if some are empty
    this.customCron = parts.join(' ');
  },

  async autoRepAction(mode = 1) {
      console.log('Creating AutoRep...');

      // if (this.schedule === 4 && !this.isValidCron) {
      //     this.$message.error("Please enter a valid CRON expression: " + this.cronError);
      //     return;
      // }

      let action = (mode === 1) ? "Create" : "Update";
      let type = "error"
      if (!this.autoRepName || this.autoRepName.trim() === "") {
        //this.$message.error("Name is required.");
        this.$notification[type]({
            message: _.startCase(action) + ' action failed - Name is required.' ,
            style: getNotificationStyle(type)
        });
        return;
      }

      if (!this.autoRepCode || this.autoRepCode.trim() === "") {
        //this.$message.error("Code is required.");
        this.$notification[type]({
            message: _.startCase(action) + ' action failed - Code is required.' ,
            style: getNotificationStyle(type)
        });
        return;
      }

      if (!this.inputSite || this.inputSite === 0) {
        //this.$message.error("Source Site is required.");
        this.$notification[type]({
            message: _.startCase(action) + ' action failed - Source Site is required.' ,
            style: getNotificationStyle(type)
        });
        return;
      }

      if (this.site_selection === 'S' && (!this.selectedRowKeys.length || this.selectedRowKeys.length === 0)) {
        //this.$message.error("Please select at least one site when using Specific Site option.");
        this.$notification[type]({
            message: _.startCase(action) + ' action failed - Please select at least one site when using Specific Site option.' ,
            style: getNotificationStyle(type)
        });
        return;
      }


      let site_ids = this.site_selection === 'A'
          ? this.siteOptions.map(site => site.id)
          : this.selectedRowKeys.filter(key => typeof key === "number");

      console.log(">>>Checker")
      console.log(site_ids)
      console.log(this.inputSite)
      console.log(site_ids.includes(this.inputSite))

      if (this.outputDocument == "OTHTRA" && site_ids.includes(this.inputSite)) {
        //this.$message.error("Source Site cannot be included in the selected sites.");
        this.$notification[type]({
            message: _.startCase(action) + ' action failed - Source Site cannot be included in the selected sites.' ,
            style: getNotificationStyle(type)
        });
        return;
      }

      // If All Sites, ensure inputSite is not included in selectedRowKeys
      // if (this.site_selection === 'A') {
      //   this.selectedRowKeys = this.selectedRowKeys.filter(siteId => siteId !== this.inputSite);
      // }

      if (this.replenishmentBy === 1) {
        if (!this.lookBackValue || this.lookBackValue <= 0) {
          //this.$message.error("Lookback value is required and must be greater than 0.");
          this.$notification[type]({
            message: _.startCase(action) + ' action failed - Lookback value is required and must be greater than 0.' ,
            style: getNotificationStyle(type)
          });
          return;
        }
      }

      let buildCron = null;

      if (this.schedule == 1) {
        buildCron = `0 0 ? * ${this.selectedDay} *`;
      }

      const scheduleMap = {
        1: buildCron,
        2: "0 0 1 * ? *",  // 1st day of month
        3: "0 0 L * ? *",  // last day of month
        5: "MANUAL"
      };

      const schedule = scheduleMap[this.schedule];

      // const scheduleMap = {
      //     1: "0 0 * * MON *",
      //     2: "0 0 * * FRI *",
      //     3: "0 0 1 * * *",
      //     4: this.customCron,
      //     5: "MANUAL"
      // };

      

      let lb = ""
      if(this.replenishmentBy === 1){
        lb = this.lookBackValue.toString() + this.lookBackType
      }


      let autoRepHash = {
          auto_replenishment: {
          replenishment_type: this.replenishmentBy,
          output_document_type: this.outputDocument,
          lookback: lb,
          schedule: schedule,
          status: "A",
          code: this.autoRepCode,
          name: this.autoRepName,
          source_site_id: this.inputSite,
          auto_replenishment_sites: site_ids
          }
      };

      console.log("Hash Value..", autoRepHash);
      this.loading = true;

      try {
          this.errors = null
          if (mode === 1) {
              const post_request = await HTTPRequest.postRequest(this.endPoint + 'auto_replenishments', null, autoRepHash);
              if (!post_request || !post_request.error) {
                  this.$emit('refreshPage', event);
              } else {
                  this.errors = post_request.error;
                  //this.$message.error(this.errors);
                  this.$notification[type]({
                    message: _.startCase(action) + ' action failed - ' + this.errors ,
                    style: getNotificationStyle(type)
                  });
                  
              }
          } else {
              const put_request = await HTTPRequest.putRequest(this.endPoint + 'auto_replenishments/' + this.profileId, null, autoRepHash);
              if (!put_request || !put_request.error) {
                  this.$emit('refreshPage', event);
              } else {
                  this.errors = put_request.error;
                  //this.$message.error(this.errors);
                  this.$notification[type]({
                    message: _.startCase(action) + ' action failed - ' + this.errors ,
                    style: getNotificationStyle(type)
                  });
              }
          }
      } catch (err) {
          console.error("Request failed:", err);
          this.errors = ["Unexpected error occurred. Please try again."];
      } finally {
          this.loading = false;
      }
  },

  sort(data){
      data.sort(function (a, b) {
          return a.name.localeCompare(b.name);
      });
  },

  onCheckSiteId(selectedRowKeys) {
    this.selectedRowKeys = selectedRowKeys;
  },
  handleCancel() {
    this.isModalVisible = false;
  },
  handleOk_() {
    this.isModalVisible = false;
  },

  async getLocationTreeData() {
    const apiData = await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_tree_sites_autorep', null);
    const treeSites = (data, root) => {
      const r = [], o = {};
      data.forEach(a => {
        if (o[a.key] && o[a.key].children) {
          a.children = o[a.key].children;
        }
        o[a.key] = a;
        if (a.parent_id === root) {
          r.push(a);
        } else {
          o[a.parent_id] = o[a.parent_id] || {};
          o[a.parent_id].children = o[a.parent_id].children || [];
          o[a.parent_id].children.push(a);
        }
      });
      return r;
    };

    const treeData = treeSites(apiData, null);
    const noLocationSites = [];

    treeData.forEach(el => {
      if (el.children && el.children.length > 0) {
        el.children.forEach(child => {
          child.title = `${child.code} - ${child.title}`;
          if (child.children && child.children.length > 0) {
            child.children.forEach(grandChild => {
              grandChild.title = `${grandChild.code} - ${grandChild.title}`;
              if (grandChild.children && grandChild.children.length > 0) {
                grandChild.children.forEach(greatGrandChild => {
                  greatGrandChild.title = `${greatGrandChild.code} - ${greatGrandChild.title}`;
                });
              }
            });
          }
        });
      } else if (!el.location) {
        noLocationSites.push(el);
      }

      if (el.code && el.title) el.title = el.title;

      if (el.children || el.code) {
        this.productLocationData.push({
          id: el.id,
          key: el.key,
          title: el.title,
          children: el.children,
        });
      }
    });

    const normalizeTree = (obj) => {
      if (obj.key && typeof obj.key === 'string' && !obj.key.startsWith('L')) {
        obj.key = parseInt(obj.key);
      }
      delete obj.id;
      Object.values(obj).forEach(val => {
        if (val && typeof val === 'object') normalizeTree(val);
      });
    };
    normalizeTree(this.productLocationData);

    this.productLocationData.sort((a, b) =>
      a.title < b.title ? -1 : Number(a.title > b.title)
    );

    if (noLocationSites.length > 0) {
      this.productLocationData.unshift({
        id: 'no-location',
        key: 'no-location',
        title: 'Sites with No Location',
        children: noLocationSites.map(site => ({
          id: site.id,
          key: parseInt(site.key),
          title: `${site.code} - ${site.title}`,
          children: site.children ? site.children : [],
        })),
      });
    }

    this.productLocationData = this.productLocationData.filter(el =>
      el.location || (el.children && el.children.length > 0)
    );

    this.filteredLocationData = [...this.productLocationData];
  },

  processSiteCodesInput() {
    this.notifMessage = [];

    if (!this.siteCodesInput.length) {
      this.notifMessage.push('No inputed site code!');
      return;
    }

    const siteCodes = this.siteCodesInput.split(',').map(code => code.trim());
    const newSelectedRowKeys = [];

    this.selectedSites = [];

    siteCodes.forEach(siteCode => {
      const node = this.findNodeBySiteCode(this.productLocationData, siteCode);
      if (node) {
        if (!newSelectedRowKeys.includes(node.key)) {
          newSelectedRowKeys.push(node.key);
        }
        this.selectedSites.push(node);
      } else {
        this.notifMessage.push(`Site code "${siteCode}" does not exist.`);
      }
    });

    if (this.notifMessage.length) {
      this.promoActionNotification('Invalid site codes', 'error');
    } else {
      this.promoActionNotification('Site codes added', 'success');
      this.isModalVisible = true;
    }

    this.selectedRowKeys = newSelectedRowKeys;

    this.$nextTick(() => {
      this.$forceUpdate();
    });
  },

  showSelectedSites() {
    this.selectedSites = [];

    const collectSelectedSites = (nodes) => {
      nodes.forEach(node => {
        if (this.selectedRowKeys.includes(node.key)) {
          this.selectedSites.push(node);
        }
        if (node.children && node.children.length > 0) {
          collectSelectedSites(node.children);
        }
      });
    };

    collectSelectedSites(this.productLocationData);
    this.isModalVisible = true;
  },

  clearSiteCodes() {
    this.siteCodesInput = '';
    this.selectedRowKeys = [];
    this.searchQuery = '';
    this.filteredLocationData = this.productLocationData;

    this.$nextTick(() => {
      this.$forceUpdate();
    });
  },

  findNodeBySiteCode(data, siteCode) {
    let foundNode = null;
    for (const node of data) {
      if (node.title.startsWith(siteCode + ' -')) {
        return node;
      }
      if (node.children && node.children.length > 0) {
        foundNode = this.findNodeBySiteCode(node.children, siteCode);
        if (foundNode) return foundNode;
      }
    }
    return null;
  },

  filterSites() {
    const query = this.searchQuery.toLowerCase().trim();

    if (!query) {
      this.filteredLocationData = this.productLocationData;
      return;
    }

    const filterTree = (data) => {
      return data.map(item => {
        const newItem = { ...item };
        if (item.children && item.children.length > 0) {
          newItem.children = filterTree(item.children);
        }
        return newItem;
      }).filter(item => {
        const matchesQuery = item.title.toLowerCase().includes(query);
        const hasMatchingChildren = item.children && item.children.length > 0;
        return matchesQuery || hasMatchingChildren;
      });
    };

    this.filteredLocationData = filterTree(this.productLocationData);
  },
},
};
</script>


